export default "__VITE_ASSET__Cixk98v0__"